export const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME
export const NOT_AUTH = process.env.REACT_APP_NOT_AUTH
export const EXPIRY_PASS = process.env.REACT_APP_EXPIRY_PASS
export const CACHE_ROUTE = process.env.REACT_APP_CACHE_ROUTE
export const APP_MENU = "APP_MENU";
export const APP_FLOW_MENU = "APP_FLOW_MENU";
export const APP_PERMS = "APP_PERMS";
export const APP_FLOW_PERMS = "APP_FLOW_PERMS";
export const CURRENT_INST = "CURRENT_INST";
export const ME_CORE_CACHE = 'ME_CORE_CACHE'